import { Button } from "antd";
import DateError from "../../styles/images/dataerror.svg";
import React, { useEffect } from "react";
import SettingError from "../../styles/images/settingerror.svg";
import WarningError from "../../styles/images/warningerror.svg";
import styles from "./technicalerror.module.scss";
import { useNavigate } from "react-router";
import { hassAccess } from "../../base/utils";

function TechnicalError({resetErrorBoundary} :any) {
  const navigate = useNavigate();

  useEffect(()=>{
    if(['/dynamicdashboard', '/dashboard'].includes(window.location.pathname)){
      navigate('/allactivity', { replace: true }); 
    }else {
      hassAccess("Dashboard/dynamicDash") 
        ?  navigate('/dynamicdashboard', { replace: true })
        :  navigate('/dashboard', { replace: true }); 
    }
    // window.location.reload();
    resetErrorBoundary?.()
  },[])

  const goBack = () => {
    navigate(-1);
  };

  return (
    <>
      <div className={styles.nodatafound}>
        <div className={styles.nodataimg}>
          <div className={styles.errorpage}>
            <img className={styles.lefticon} src={WarningError} alt="" />
            {/* <img className={styles.lefticon} src={DateError} alt="" /> */}
            {/* <img className={styles.lefticon} src={SettingError} alt="" /> */}
            <p>This may be because of a technical error that were working to get fixed. Try reloading this page</p>
            <Button onClick={goBack} className="buttonGreenCreate">
              Go Back
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}

export default TechnicalError;
